import { Box, Button, Dialog, DialogContent, Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { PaymentRequestBalanceDto } from "@inosio/payments-sdk";
import WhiteInosio from "../../icons/whiteinosio.svg";
import BackIcon from '../../icons/back1.svg';
import { useState } from "react";
import CheckBox from "../../icons/CheckBox.svg"
import UnCheckedBox from "../../icons/UnCheckedBox.svg"
import { makeStyles } from '@mui/styles';
import { getInosioTermsAndConditions, selectOnboardingApplicationState } from '../../pmui/onboarding/sagas/pmonboardingSlice';
import { useDispatch, useSelector } from 'react-redux';
import TermsDialog from '../../components/TermsDialog';
import { useFormik } from "formik";
import { schemaValidationCreateAnAccountModal, schemaValidationCreateAnAccountModalType } from '../../utils/validation';
import { InputField } from '../../components/InputController';

interface CreateAnAccountModalProp {
    open: boolean;
    onBackClick: () => void
    iHaveAnAccountClick: () => void
    PaymentRequestDetails: PaymentRequestBalanceDto | null;
}


const useStyles = makeStyles((theme) => ({

    termsAndConditionLink: {
        fontFamily: "Work Sans",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "22px",
        color: "#39A2DB",
        marginTop: "18px",
        cursor: "pointer",
    }

}));

const CreateAnAccountModal = (props: CreateAnAccountModalProp) => {

    const { open, onBackClick, PaymentRequestDetails, iHaveAnAccountClick } = props;
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const [accepted, setAccepted] = React.useState(false);
    const { contract } = useSelector(selectOnboardingApplicationState);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const classes = useStyles();
    const dispatch = useDispatch();

    const initialValues: schemaValidationCreateAnAccountModalType = {
        email: PaymentRequestDetails?.Email!,
        password: "",
        confirmPassword: "",
    };

    const formik = useFormik<schemaValidationCreateAnAccountModalType>({
        initialValues,
        validationSchema: schemaValidationCreateAnAccountModal,
        onSubmit: (values) => {            
        }
    })



    const [globalError] = useState('');
    const [openInosio, setOpenInosio] = React.useState(false);
    const style = {
        height: isOnMobileScreen ? "100%" : "523px",
    };


    const handleCloseInosio = () => {
        setOpenInosio(false);
        setAccepted(true)
    };

    useEffect(() => {
        if (formik.isValid) setDisableSubmit(false);
    }, [formik.isValid, disableSubmit]);

    useEffect(() => {
        if (!contract.InosioTsCs.Text) {
            dispatch({
                type: getInosioTermsAndConditions.type
            })
        }
    }, [dispatch])


    return (
        <Dialog open={open}
            fullScreen={isOnMobileScreen}
            BackdropProps={{
                invisible: true,
            }}
            fullWidth={true}
            disableEnforceFocus
            style={{
                background: "none",
            }}
            PaperProps={{
                style: {
                    pointerEvents: "auto",
                    borderRadius: isOnMobileScreen ? "0px" : "24px",
                    width: isOnMobileScreen ? "100%" : "472px",
                    boxShadow: "none",
                    overflow: "hidden"
                },
            }}
            disableEscapeKeyDown={true}
        >
            <DialogContent>
                <Box sx={style}>
                    <Grid item display='flex' flexDirection='column' alignItems='center' sx={{ height: '100%' }}>
                        <Grid item display='flex' justifyContent='center'>
                            <Grid item display='flex' pl={6} sx={{ width: '340px' }} justifyContent='center' mt={!globalError.length ? 6 : 0} mb={!globalError.length ? 4 : 1}  >
                                <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
                                <Typography
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        fontSize: '18px',
                                        lineHeight: '23px',
                                        color: '#14142B',
                                        textAlign: 'left',
                                        padding: '15px'
                                    }}>
                                    {PaymentRequestDetails?.CompanyName}
                                </Typography>
                            </Grid>
                        </Grid>
                        <div >
                            {globalError.length ? (
                                <Grid item sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginBottom: "10px",
                                    borderTop: "2px  solid #DB3939",
                                    borderRadius: "24px",
                                    padding: "12px 20px",
                                    width: "340px",
                                    height: "49px",
                                }}>
                                    <Typography
                                        style={{
                                            fontFamily: "BMWHelvetica",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            lineHeight: "18px",
                                            color: "#DB3939",
                                        }}
                                    >
                                        {" "}
                                        {globalError}
                                    </Typography>
                                </Grid>
                            ) : (
                                ""
                            )}

                            <Box component='form' sx={{
                                backgroundColor: "#FFFFFF",
                                borderRadius: "20px",
                                width: "340px",
                                border: "none",
                            }} onSubmit={formik.handleSubmit}>
                                <Grid item>
                                    <Grid item>
                                        <InputField name={"email"} defaultValue={PaymentRequestDetails?.Email} label={"Email"} placeholder={"Email"} value={formik.values.email} isError={false} errors={formik.errors?.email} touched={formik.touched?.email} onBlur={formik.handleBlur} onChange={(e) => formik.setFieldValue("email", e.target.value)} />
                                    </Grid>
                                    <Grid item>
                                        <InputField
                                            name={"password"}
                                            placeholder={"Password"}
                                            type="password"
                                            label={"Password"}
                                            isError={false}
                                            errors={formik.errors?.password}
                                            touched={formik.touched?.password}
                                            onBlur={formik.handleBlur}
                                            onChange={(e) => formik.setFieldValue("password", e.target.value)} />
                                    </Grid>
                                    <Grid item>
                                        <InputField
                                            name={"confirmPassword"}
                                            placeholder={"Confirm Password"}
                                            type="password"
                                            label={"Confirm Password"}
                                            isError={false}
                                            errors={formik.errors?.confirmPassword}
                                            touched={formik.touched?.confirmPassword}
                                            onBlur={formik.handleBlur}
                                            onChange={(e) => formik.setFieldValue("confirmPassword", e.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item mb={1} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                                    <Typography style={{
                                        fontFamily: "Work Sans",
                                        paddingLeft: "18px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        fontSize: "16px",
                                        lineHeight: "22px",
                                        marginTop: !globalError.length ? '15px' : '5px'
                                    }} >
                                        Accept

                                        <span className={classes.termsAndConditionLink} onClick={() => { setOpenInosio(true) }}>T&Cs</span>
                                    </Typography>
                                    <Grid ml={1} mt={1.3} item sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <img src={accepted ? CheckBox : UnCheckedBox} style={{ width: "11px", height: "11px" }} alt='Checkmark' onClick={() => setAccepted(!accepted)} />
                                    </Grid>
                                </Grid>
                                <Grid item display='flex' justifyContent='space-between' flexDirection={isOnMobileScreen ? 'column' : 'row'}>
                                    {
                                        isOnMobileScreen ? (
                                            <>
                                                <Grid item pb={1}>
                                                    <Button variant='contained' sx={{
                                                        font: "14px Work Sans !important",
                                                        width: "100%",
                                                        height: "49px",
                                                        borderRadius: "24px !important",
                                                        backgroundColor: "#39A2DB",
                                                        textTransform: "capitalize",
                                                        color: "#FFFFFF !important"
                                                    }} type='submit'>
                                                        Sign In
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button sx={{
                                                        font: "14px Work Sans 400 !important",
                                                        border: "1px solid #39A2DB ",
                                                        width: "100%",
                                                        height: "49px",
                                                        borderRadius: "24px",
                                                        textTransform: "capitalize",
                                                    }} onClick={iHaveAnAccountClick}> I have an account </Button>
                                                </Grid>
                                            </>
                                        )
                                            :
                                            (
                                                <>
                                                    <Grid item>
                                                        <Button sx={{
                                                            font: "14px Work Sans 400 !important",
                                                            border: "1px solid #39A2DB ",
                                                            width: "200px",
                                                            height: "49px",
                                                            borderRadius: "24px",
                                                            textTransform: "capitalize",
                                                        }} onClick={iHaveAnAccountClick}> I have an account </Button>
                                                    </Grid>
                                                    <Grid item>
                                                        <Button variant='contained' sx={{
                                                            font: "14px Work Sans 400 !important",
                                                            width: "113px",
                                                            height: "49px",
                                                            borderRadius: "24px !important",
                                                            textTransform: "capitalize",
                                                            backgroundColor: "#39A2DB",
                                                            color: "#FFFFFF !important",
                                                        }} type='submit'>
                                                            Sign In
                                                        </Button>
                                                    </Grid>
                                                </>
                                            )
                                    }

                                </Grid>
                            </Box>
                        </div>
                        <TermsDialog open={openInosio} scroll={true} text={contract.InosioTsCs.Text} title="Inosio Agreement" handleConfirm={handleCloseInosio} buttonText="Agree" />
                    </Grid>
                </Box>
                <Grid item sx={{ position: 'absolute', top: 15, left: 15 }}>
                    <img src={BackIcon} alt="back" style={{ cursor: 'pointer' }} onClick={onBackClick} />
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default CreateAnAccountModal;

